document.addEventListener('DOMContentLoaded', () => {
    const wikiCards = Array.from(document.querySelectorAll('.wiki-cards-grid .wiki-cards .card'));

    if (wikiCards.length <= 0) {
        return;
    }

    wikiCards.forEach((wikiCard) => {
        const wikiShowMore = Array.from(wikiCard.getElementsByClassName('show-more'));
        const wikiShowLess = Array.from(wikiCard.getElementsByClassName('show-less'));

        if (wikiShowMore.length === 1) {
            wikiShowMore[0].addEventListener('click', (event) => {
                event.preventDefault();
                wikiCard.classList.add('show');
            });
        }

        if (wikiShowLess.length === 1) {
            wikiShowLess[0].addEventListener('click', (event) => {
                event.preventDefault();
                wikiCard.classList.remove('show');
            });
        }
    });
});
